<template>
  <div>
    <router-view></router-view>
    <loader></loader>
    <global-loader />
    <flash-message></flash-message>
    <notivuecation />
    <error-toastr />
  </div>
</template>

<style>
/* .fade-enter-active, .fade-leave-active {
      transition: opacity .5s
    }
    .fade-enter, .fade-leave-active {
      opacity: 0
    } */
</style>


<script>
import { API_URL } from "./env.js";
import Loader from "./components/ui/Loader.vue";
import GlobalLoader from "./components/ui/GlobalLoader.vue";
import ErrorToastr from "./components/ui/ErrorToastr.vue";

export default {
  components: {
    Loader,
    GlobalLoader,
    ErrorToastr
  },
  methods: {
    fetchUser() {
      // this.$store.dispatch("GET_USER");
    }
  },
  created: function() {
    this.$store.dispatch("INIT");
    this.$loading(false);
    // this.fetchUser();
  }
};
</script>
